import GenericForm from './generic-form';

export default GenericForm;
